<img [src]="'assets/img/icons/' + icon + '.svg'" />
